import { Space, Form, Tabs, Button } from 'antd';
import { useOrderEditContext } from './OrderEditContext';
import OrderGeneralCard from './OrderGeneralCard';
import OrderLineItemsCard from './OrderLineItemsCard';
import OrderSummaryCard from './OrderSummaryCard';
import ProductPickerPanel from './ProductPickerPanel';

const OrderEditMobile = () => {
    const { form, onFinish, onFinishFailed, data, navigate } = useOrderEditContext();

    const items = [
        {
            key: 'general',
            label: 'Khách hàng',
            children: <OrderGeneralCard />,
        },
        {
            key: 'products',
            label: 'Sản phẩm',
            children: (
                <Space direction="vertical" size={8} style={{ width: '100%' }}>
                    <OrderLineItemsCard />
                    <ProductPickerPanel />
                </Space>
            ),
        },
        {
            key: 'summary',
            label: 'Tổng',
            children: <OrderSummaryCard />,
        },
    ];

    return (
        <Form
            name="basic"
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout='vertical'
        >
            <Tabs items={items} />

            <div style={{ height: 72 }} />
            <div
                style={{
                    position: 'fixed',
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1000,
                    background: '#fff',
                    borderTop: '1px solid #f0f0f0',
                    padding: '8px 12px calc(8px + env(safe-area-inset-bottom, 0px))',
                }}
            >
                <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                    {data?.id && (
                        <Button onClick={() => navigate(`/order/${data.id}`)}>Trở về</Button>
                    )}
                    <Button type='primary' onClick={() => form.submit()}>Lưu</Button>
                </Space>
            </div>
        </Form>
    );
};

export default OrderEditMobile;
